var _defs, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBenefitLoesungen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.02 34.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #defc70;\n      }\n\n      .st1 {\n        fill: #fff;\n        font-family: DINPro-Regular, DINPro;\n        font-size: 14.07px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.98,17.95l7.03-7.03,3.57-.22.41-.18,2.41-2.29.2-.4.06-.55-.19-.53-1.15-1.15,1.5-1.5-.92-.92-1.51,1.5-1.07-1.07-.43-.19-.62-.03-.5.21-2.31,2.47-.17.41-.2,3.52-7.03,7.03.92.92ZM24.57,6.79l1.95-2.08.96.89-1.78,1.78.92.92,1.78-1.78.93.93-2.07,1.96-2.85.18.16-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.97,10.16l.56-1.17-.59-.28c-3.52-1.67-7.73-.95-10.49,1.81-1.74,1.74-2.7,4.06-2.7,6.52s.96,4.78,2.7,6.52c1.8,1.8,4.16,2.7,6.52,2.7s4.72-.9,6.52-2.7c2.76-2.77,3.49-6.99,1.8-10.51l-.28-.59-1.17.56.28.59c1.45,3.03.83,6.66-1.54,9.03-3.09,3.09-8.12,3.09-11.21,0-1.5-1.5-2.32-3.49-2.32-5.6s.82-4.11,2.32-5.6c2.37-2.37,5.99-2.99,9.01-1.55l.59.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.03,13.68h.65s.02-1.29.02-1.29h-.65c-1.24,0-2.47.45-3.37,1.35-1.81,1.81-1.81,4.77,0,6.58.88.88,2.05,1.36,3.29,1.36s2.41-.48,3.29-1.36c.9-.9,1.39-2.1,1.36-3.37v-.65s-1.31.02-1.31.02v.65c.03.92-.32,1.78-.97,2.43-1.27,1.27-3.48,1.27-4.74,0-1.31-1.31-1.31-3.43,0-4.74.65-.65,1.54-1.03,2.43-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.39,10.97l-1.19.51.26.6c2.04,4.73,1,10.14-2.64,13.79-2.36,2.36-5.5,3.66-8.84,3.66s-6.48-1.3-8.84-3.66c-4.87-4.87-4.87-12.8,0-17.67,3.64-3.65,9.05-4.68,13.79-2.64l.6.26.51-1.19-.6-.26c-5.22-2.25-11.2-1.11-15.22,2.92-5.38,5.38-5.38,14.13,0,19.51,2.61,2.61,6.07,4.04,9.76,4.04s7.15-1.43,9.76-4.04c4.02-4.02,5.17-10,2.92-15.22l-.26-.6Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(30.21 22.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(33.58 22.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBenefitLoesungen);
export default __webpack_public_path__ + "static/media/Icons_Benefit_Loesungen.acd5cb3125ec38d529dae4e8ee45d04c.svg";
export { ForwardRef as ReactComponent };